((Drupal, Splide) => {
  Drupal.behaviors.threeDCarouselSlide = {
    attach(context) {
      if (context.getElementsByClassName('splide-3d-carousel').length) {
        const splide = new Splide('.splide-3d-carousel', {
          type: 'loop',
          perPage: 5,
          focus: 'center',
          autoWidth: true,
          updateOnMove: true,
          speed: 1000,
          drag: false,
          breakpoints: {
            1023: {
              drag: true
            }
          }
        });

        splide.on('mounted', function() {
          const Slide = splide.Components.Slides.getAt(0);
          const slideCaption = Slide.slide.querySelector('.media-image-caption')?.innerHTML;
          splide.root.querySelector('.splide__caption').innerHTML = slideCaption;
        });

        splide.on('resize', function() {
          const track = splide.Components.Elements.track;
          const arrows = splide.Components.Arrows.arrows;

          if (window.innerWidth <= 700) {
            let height = track.offsetHeight;
            // 44px is the height of the arrow element.
            let arrowTop = (height / 2) - 22;

            if (typeof arrows.prev != 'undefined') {
              arrows.prev.style.top = arrowTop + 'px';
            }
            if (typeof arrows.next != 'undefined') {
              arrows.next.style.top = arrowTop + 'px';
            }
          }
          else {
            arrows.prev.style.top = '';
            arrows.next.style.top = '';
          }
        });

        splide.on('move', function(newIndex, prevIndex, destIndex) {
          // Switch caption text.
          const captionArea = splide.root.querySelector('.splide__caption');
          const nextSlide = splide.Components.Slides.getAt(newIndex);
          const slideCaption = nextSlide.slide.querySelector('.media-image-caption')?.innerHTML;
          captionArea.innerHTML = slideCaption;

          const Slides = splide.Components.Slides;
          const activeIndex = destIndex;
          const numSlides = Slides.getLength(true);
          // Loop through all the slides, including clones.
          Slides.forEach((slide, index) => {
            const slideElement = slide.slide;
            // Apply styles to non-visible elements accordingly.
            if (index % numSlides === (activeIndex - 1 + numSlides) % numSlides) {
              slideElement.classList.add('clone-prev');
              slideElement.classList.remove('clone-next');
            } else if (index % numSlides === (activeIndex + 1 + numSlides) % numSlides) {
              slideElement.classList.add('clone-next');
              slideElement.classList.remove('clone-prev');
            } else {
              slideElement.classList.remove('clone-prev');
              slideElement.classList.remove('clone-next');
            }
          });
        });

        splide.mount();
      }
    },
  };
})(Drupal, Splide);
